import { render, staticRenderFns } from "./service_location.vue?vue&type=template&id=bba0c964"
import script from "./service_location.vue?vue&type=script&lang=js"
export * from "./service_location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports